import React,{ Component } from 'react';
import {Link} from 'react-router-dom'
import Navigation from '../../components/navigation'
import lehuilin from './../../pic/lehuilin.jpg'
import linsheng from './../../pic/linsheng.jpg'
import sunyiwen from './../../pic/sunyiwen.jpg'
import xuanqi from './../../pic/xuanqi.jpg'
import zhuyeming from './../../pic/zhuyeming.jpg'
import xuyingming from './../../pic/xuyingming.jpg'
import sunwei from './../../pic/sunwei.jpg'
import shijialuo from './../../pic/shijialuo.jpg'
import playOS from './../../images/play_circle_orange_s.png'
import './index.css'
export default class match extends Component {
    state = {
        starList:[],
        starNameList:[],
        starPage:1,
        tabIndex:1,
        year:'2019',
        month:'12',
        videoCamList:[],
        videoHeroList:[]
    }
    componentWillMount(){
        var star = [lehuilin,linsheng,sunyiwen,xuanqi,zhuyeming,xuyingming,sunwei,shijialuo]
        this.setState({starList:star});
        var star1 = ['乐慧林','林声','孙一文','许安琪','朱明叶','许英明','孙伟','施嘉洛'];
        this.setState({starNameList:star1});
        var videoCamList = ['a01786ijqla','a0930ar1pv3','t09287v6zmt','j30065rrb9d','k09022di15l','j0914to7cbv','f0929g3wzib','x03054ms6rg','w07459h9de8'];
        this.setState({videoCamList:videoCamList});
        var videoHeroList = ['u0029cj6joi','hero03.mp4','p0818mq4x5k','m0365vyb5vh','s300570td9z','hero06.mp4'];
        this.setState({videoHeroList:videoHeroList});
    }
    starPageAdd=()=>{
        if(this.state.starPage === 3) return;
        var page = this.state.starPage;
        this.setState({starPage:++page})
    }
    starPageRemove=()=>{
        if(this.state.starPage === 1) return;
        var page = this.state.starPage;
        this.setState({starPage:--page})
    }
    changeTabIndex=(index)=>{
        this.setState({tabIndex:index})
    }
    changeYear=(year)=>{
        this.setState({year:year})
    }
    changeMonth=(month)=>{
        this.setState({month:month})
    }
    render(){
        return (
            <main>
                <Navigation tab="match"></Navigation>
                <div className="event_plan">
                    <div className="plan">
                        <p>赛事计划</p>
                        <p className={this.state.year === '2019' ? 'active' : ''} onClick={this.changeYear.bind(this,'2019')}>2019</p>
                        <p className={this.state.year === '2020' ? 'active' : ''} onClick={this.changeYear.bind(this,'2020')}>2020</p>
                    </div>
                    <ul className="month">
                        <li onClick={this.changeMonth.bind(this,'01')}><div className="spot" style={{'background':this.state.month == '01' ? 'rgba(255,93,56,1)' : ''}}></div><span>01月</span></li>
                        <li onClick={this.changeMonth.bind(this,'02')}><div className="spot" style={{'background':this.state.month == '02' ? 'rgba(255,93,56,1)' : ''}}></div><span>02月</span></li>
                        <li onClick={this.changeMonth.bind(this,'03')}><div className="spot" style={{'background':this.state.month == '03' ? 'rgba(255,93,56,1)' : ''}}></div><span>03月</span></li>
                        <li onClick={this.changeMonth.bind(this,'04')}><div className="spot" style={{'background':this.state.month == '04' ? 'rgba(255,93,56,1)' : ''}}></div><span>04月</span></li>
                        <li onClick={this.changeMonth.bind(this,'05')}><div className="spot" style={{'background':this.state.month == '05' ? 'rgba(255,93,56,1)' : ''}}></div><span>05月</span></li>
                        <li onClick={this.changeMonth.bind(this,'06')}><div className="spot" style={{'background':this.state.month == '06' ? 'rgba(255,93,56,1)' : ''}}></div><span>06月</span></li>
                        <li onClick={this.changeMonth.bind(this,'07')}><div className="spot" style={{'background':this.state.month == '07' ? 'rgba(255,93,56,1)' : ''}}></div><span>07月</span></li>
                        <li onClick={this.changeMonth.bind(this,'08')}><div className="spot" style={{'background':this.state.month == '08' ? 'rgba(255,93,56,1)' : ''}}></div><span>08月</span></li>
                        <li onClick={this.changeMonth.bind(this,'09')}><div className="spot" style={{'background':this.state.month == '09' ? 'rgba(255,93,56,1)' : ''}}></div><span>09月</span></li>
                        <li onClick={this.changeMonth.bind(this,'10')}><div className="spot" style={{'background':this.state.month == '10' ? 'rgba(255,93,56,1)' : ''}}></div><span>10月</span></li>
                        <li onClick={this.changeMonth.bind(this,'11')}><div className="spot" style={{'background':this.state.month == '11' ? 'rgba(255,93,56,1)' : ''}}></div><span>11月</span></li>
                        <li onClick={this.changeMonth.bind(this,'12')}><div className="spot" style={{'background':this.state.month == '12' ? 'rgba(255,93,56,1)' : ''}}></div><span>12月</span></li>
                    </ul>
                    <div className="event">
                        <ul>
                            {this.state.year == '2019' && this.state.month == '05' &&
                            <div>
                                <li>
                                    <p>全国青年击剑锦标赛暨二青会预赛第二站</p>
                                    <p style={{color:'#FF5D38'}}>05.30-06.05</p>
                                    <p>长沙</p>
                                </li>
                            </div>
                            }
                            {this.state.year == '2019' && this.state.month == '10' &&
                            <div>
                                <li>
                                    <p>全国击剑锦标赛</p>
                                    <p style={{color:'#FF5D38'}}>10.28</p>
                                    <p>西安</p>
                                </li>
                            </div>
                            }
                            {this.state.year == '2019' && this.state.month == '11' &&
                            <div>
                                <li>
                                    <p>第25届中国大学生击剑锦标赛</p>
                                    <p style={{color:'#FF5D38'}}>11.20-11.26</p>
                                    <p>厦门</p>
                                </li>
                                <li>
                                    <p>陕西省青少年击剑俱乐部联赛</p>
                                    <p style={{color:'#FF5D38'}}>11.23</p>
                                    <p>陕西</p>
                                </li>
                            </div>
                            }
                            {(this.state.year == '2020' || this.state.month == '01' || this.state.month == '02' || this.state.month == '03' || this.state.month == '04' || this.state.month == '06' || this.state.month == '07' || this.state.month == '08' || this.state.month == '09' || this.state.month == '12') &&
                                <div className="no_match">
                                    <p>没有赛事</p>
                                </div>
                            }
                        </ul>
                        {/* <img src={arrowRight} alt=""></img>
                        <img src={arrowLeft} alt=""></img> */}
                    </div>
                </div>
                <div className="star">
                    <div className="layout">
                        <div>
                            <span>击剑明星</span>
                        </div>
                    </div>   
                    <ul className="list" style={{marginLeft:-(this.state.starPage-1)*12.32+'rem'}}>
                        {this.state.starList.map((star,index) =>
                            <li key={index}><Link to={'/match/'+index}>
                                <img src={star} alt=""/>
                                <p>{this.state.starNameList[index]}</p>
                            </Link></li>
                        )}
                    </ul>
                </div>          
                <div className="event_review">
                    <p>赛事回顾</p>
                    <div className="tab">
                        <span className={this.state.tabIndex ===1 ? "active" : ''} onClick={this.changeTabIndex.bind(this,1)}>冠军赛</span>
                        <span className={this.state.tabIndex ===2 ? "active" : ''} onClick={this.changeTabIndex.bind(this,2)}>英雄传说</span>
                        {/* <span className={this.state.tabIndex ===3 ? "active" : ''} onClick={this.changeTabIndex.bind(this,3)}>击剑情报局</span> */}
                    </div>
                    {
                        this.state.tabIndex === 1 &&
                        <ul className="list">
                            <Link to={"/video/"+this.state.videoCamList[1]+'/1'}>
                            <li>
                                <img src={require('./../../pic/champion02.jpg')} alt=""></img><p>2018-2019赛季全国击剑冠军赛</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：200</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoCamList[2]+'/1'}>
                            <li>
                                <img src={require('./../../pic/champion03.jpg')} alt="2018-2019赛季全国击剑总决赛（二）"></img><p>2018-2019赛季全国击剑总决赛（二）</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：124</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoCamList[3]+'/1'}>
                            <li>
                                <img src={require('./../../pic/champion04.jpg')} alt="2019“国庆杯”武汉市击剑冠军赛"></img><p>2019“国庆杯”武汉市击剑冠军赛</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：95</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoCamList[4]+'/1'}>
                            <li>
                                <img src={require('./../../pic/champion05.jpg')} alt="2019世界击剑锦标赛女重团体决赛（中国VS俄罗斯）"></img><p>2019世界击剑锦标赛女重团体决赛（中国VS俄罗斯）</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：153</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoCamList[5]+'/1'}>
                            <li>
                                <img src={require('./../../pic/champion06.jpg')} alt="二青会击剑比赛 西安女子花剑勇夺团体冠军"></img><p>二青会击剑比赛 西安女子花剑勇夺团体冠军</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：76</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoCamList[6]+'/1'}>
                            <li>
                                <img src={require('./../../pic/champion07.jpg')} alt="全国击剑冠军赛总决赛第三日集锦"></img><p>全国击剑冠军赛总决赛第三日集锦</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：203</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoCamList[7]+'/1'}>
                            <li>
                                <img src={require('./../../pic/lehuilin_match_01.png')} alt="2016国际剑联上海花剑大奖赛"></img><p>2016国际剑联上海花剑大奖赛</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：91</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoCamList[8]+'/1'}>
                            <li>
                                <img src={require('./../../pic/linsheng_match_01.png')} alt="2018击剑世锦赛 女重个人 林声 vs KOR"></img><p>2018击剑世锦赛 女重个人 林声 vs KOR</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：207</span>
                                </div>
                            </li>
                            </Link>
                        </ul>
                        
                    }
                    {
                        this.state.tabIndex === 2 &&
                        <ul className="list">
                            <Link to={"/video/"+this.state.videoHeroList[1]+'/2'}>
                            <li>
                                <img src={require('./../../pic/hero02.jpg')} alt=""></img><p>广东击剑队队员邓小浩专访</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：152</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoHeroList[2]+'/1'}>
                            <li>
                                <img src={require('./../../pic/hero03.jpg')} alt=""></img><p>击剑运动员 雷声 演讲</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：210</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoHeroList[3]+'/1'}>
                            <li>
                                <img src={require('./../../pic/hero04.jpg')} alt=""></img><p>击剑运动员孙伟 访谈</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：203</span>
                                </div>
                            </li>
                            </Link>
                            <Link to={"/video/"+this.state.videoHeroList[4]+'/1'}>
                            <li>
                                <img src={require('./../../pic/hero05.jpg')} alt=""></img><p>中国击剑访谈</p>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：125</span>
                                </div>
                            </li>
                            </Link>
                        </ul>
                    }      
                </div>
            </main>
        )
    }
};